// extracted by mini-css-extract-plugin
export default {"copilotChatPanel":"ChatPanel-module__copilotChatPanel--YfhVH","Overlay--motion-scaleFade":"ChatPanel-module__Overlay--motion-scaleFade--uKAx2"};